module.exports = __webpack_public_path__ + "img/symbol_6.0107253a.png";